import { useQueries } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { AttachMoney, Person } from '@mui/icons-material';
import { Grid } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { USD } from '@barboxx/utils';

import DataList from './components/cards/DataList';
import PendingSignupItem from './components/cards/PendingSignupItem';
import SmallCount from './components/cards/SmallCount';
import { SmallGridItem } from './components/GridItems';

export function InternalDashboard() {
    const navigate = useNavigate();

    const [dashboardSummary, pendingSignups] = useQueries({
        queries: [
            {
                queryKey: ['dashboard'],
                queryFn: () => Api.Dashboard.getInternalDashboardSummary(),
            },
            {
                queryKey: ['businessSignups'],
                queryFn: () => Api.Businesses.getSignups({ size: 10, page: 0 }),
            },
        ],
    });

    const handleSignupClick = () => {
        navigate(`/signups`);
    };
    const handleSignupItemClick = (id: number) => {
        navigate(`/signups/${id}`);
    };
    const handleUsersClick = () => {
        navigate(`/users`);
    };
    const handleCustomersClick = () => {
        navigate(`/customers`);
    };
    const handleBusinessesClick = () => {
        navigate(`/businesses`);
    };

    return (
        <QueryRenderer results={dashboardSummary}>
            {data => (
                <Grid container direction="row" spacing={2}>
                    <SmallGridItem>
                        <SmallCount
                            title="Total Users"
                            value={data.userCount}
                            icon={<Person />}
                            onClick={handleUsersClick}
                        />
                    </SmallGridItem>
                    <SmallGridItem>
                        <SmallCount
                            title="Total Businesses"
                            value={data.businessCount}
                            icon={<Person />}
                            onClick={handleBusinessesClick}
                        />
                    </SmallGridItem>
                    <SmallGridItem>
                        <SmallCount
                            title="Total Customers"
                            value={data.customerCount}
                            icon={<Person />}
                            onClick={handleCustomersClick}
                        />
                    </SmallGridItem>
                    <SmallGridItem>
                        <SmallCount
                            title="Total Sales"
                            value={USD(data.totalSales).format()}
                            icon={<AttachMoney />}
                        />
                    </SmallGridItem>
                    <SmallGridItem>
                        <SmallCount
                            title="Total Profit"
                            value={USD(data.totalProfit).format()}
                            icon={<AttachMoney />}
                        />
                    </SmallGridItem>
                    <SmallGridItem>
                        <DataList
                            data={pendingSignups.data?.data?.results ?? []}
                            error={pendingSignups.error}
                            loading={pendingSignups.isLoading}
                            title="Pending Signups"
                            noDataText="No Signups"
                            onClick={handleSignupClick}
                            ItemComponent={PendingSignupItem}
                            onItemClick={handleSignupItemClick}
                        />
                    </SmallGridItem>
                </Grid>
            )}
        </QueryRenderer>
    );
}
